const a = {
  padding: "8px 14px"
};
export {
  a as default
};
